import Alpine from "alpinejs";
import buyTableComponent from "../alpine/buyTableComponent.ts";
import checkout from "../alpine/checkout";
import clipboardComponent from "../alpine/clipboardComponent";
import cutmeasureComponent from "../alpine/cutmeasureComponent.ts";
import downloadComponent from "../alpine/downloadComponent";
import downloadOrderConfirmation from "../alpine/downloadOrderConfirmation.ts";
import filterComponent from "../alpine/filterComponent.ts";
import filterSelectAllComponent from "../alpine/filterSelectAllComponent.ts";
import forgotPassword from "../alpine/forgotPassword";
import loginComponent from "../alpine/loginComponent.ts";
import miniCartComponent from "../alpine/minicartComponent.ts";
import orderConfirmationPage from "../alpine/orderConfirmationPage";
import pdfProductSheet from "../alpine/pdf-product-sheet";
import productPage from "../alpine/productPage";
import productPrice from "../alpine/productPrice.ts";
import registerForm from "../alpine/registerForm";
import registerSetPassword from "../alpine/registerSetPassword";
import resetPassword from "../alpine/resetPassword";
import scrollSlider from "../alpine/scrollSlider";
import splideComponent from "../alpine/splideComponent";
import { basketNotificationStore } from "../alpine/stores/basketNotificationStore.ts";
/**
 * Extend the Window interface to include Alpine for TypeScript
 */
declare global {
	interface Window {
		Alpine: typeof Alpine;
	}
}

/**
 * Make Alpine available globally (for debugging purposes)
 */
window.Alpine = Alpine;

Alpine.store("orderTotal", {});
Alpine.store("basketNotification", basketNotificationStore);

/**
 * Register Alpine components
 */
Alpine.data("clipboard", clipboardComponent);
Alpine.data("scrollSlider", scrollSlider);
Alpine.data("splide", splideComponent);
Alpine.data("minicart", miniCartComponent);
Alpine.data("filter", filterComponent);
Alpine.data("pdfProductSheet", pdfProductSheet);
Alpine.data("cutmeasure", cutmeasureComponent);
Alpine.data("resetPassword", resetPassword);
Alpine.data("forgotPassword", forgotPassword);
Alpine.data("checkout", checkout);
Alpine.data("buyTable", buyTableComponent);
Alpine.data("filterSelectAll", filterSelectAllComponent);
Alpine.data("productPrice", productPrice);
Alpine.data("login", loginComponent);
Alpine.data("registerForm", registerForm);
Alpine.data("registerSetPassword", registerSetPassword);
Alpine.data("download", downloadComponent);
Alpine.data("productPage", productPage);
Alpine.data("orderConfirmationPage", orderConfirmationPage);
Alpine.data("downloadOrderConfirmation", downloadOrderConfirmation);

Alpine.start();
